import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ShieldCheck, Clock, Award, ChevronRight } from 'lucide-react';
import { websiteData } from '../data/websiteData.js';

export default function Hero() {
  const trustPoints = [
    "Quality Materials",
    "Expert Engineering",
    "Durable Structures",
    "On-Time Execution"
  ];

  return (
    <section className="hero">
      {/* Background Image & Premium Navy Overlay */}
      <img 
        src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1600&q=80" 
        alt="Vijay Industry pre-engineered steel structure construction and factory shed fabrication in Coimbatore" 
        className="hero-bg-image" 
      />
      <div className="hero-bg-overlay"></div>

      <div className="container">
        <div className="hero-container">
          {/* Hero Content Left */}
          <div className="hero-content">
            <span className="hero-eyebrow">{websiteData.companyName}</span>
            <h1 className="hero-title">{websiteData.tagline}</h1>
            <p className="hero-description">
              {websiteData.taglineSecondary}. We engineer premium pre-engineered buildings, 
              roofing structures, mild steel structures, and custom stainless steel railings 
              designed for lifetime durability.
            </p>
            
            {/* CTA Actions */}
            <div className="hero-actions">
              <Link 
                to="/contact" 
                className="btn btn-primary"
              >
                Get a Quote <ChevronRight size={16} />
              </Link>
              <Link 
                to="/services" 
                className="btn btn-secondary"
              >
                Explore Services
              </Link>
            </div>

            {/* Core Trust Checklist */}
            <div className="hero-trust-grid">
              {trustPoints.map((point, index) => (
                <div key={index} className="hero-trust-item">
                  <CheckCircle size={18} className="hero-trust-icon" />
                  <span className="hero-trust-text">{point}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Accolades Badge Panel Right */}
          <div className="hero-image-panel">
            <div className="hero-badge-card" aria-label="Vijay Industry Accolades">
              <h3 style={{ color: '#FFFFFF', fontSize: '1.1rem', marginBottom: '0.5rem', fontWeight: 700 }}>
                Project Excellence
              </h3>
              
              <div className="hero-badge-item">
                <div className="hero-badge-icon">
                  <ShieldCheck size={18} />
                </div>
                <div>
                  <h4 className="hero-badge-title">Quality Assured</h4>
                  <p className="hero-badge-desc">100% certified steel grade fabrication</p>
                </div>
              </div>

              <div className="hero-badge-item">
                <div className="hero-badge-icon">
                  <Clock size={18} />
                </div>
                <div>
                  <h4 className="hero-badge-title">On-Time Delivery</h4>
                  <p className="hero-badge-desc">Efficient pre-engineered structures</p>
                </div>
              </div>

              <div className="hero-badge-item">
                <div className="hero-badge-icon">
                  <Award size={18} />
                </div>
                <div>
                  <h4 className="hero-badge-title">Expert Workmanship</h4>
                  <p className="hero-badge-desc">Experienced architects & welders</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
